import {
    formatReportCurrency,
    formatReportDateTime,
    getContainerTeusFromRow,
    getContainerTypeFromRow,
} from "@/utility/fclReportHelpers";

const cell = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
};

export const EXPORT_BOOKING_LIST_COLUMNS = [
    {
        key: "fileNo",
        label: "FILE NO",
        sticky: "left",
        width: 160,
        render: (row) => cell(row.fileNo),
    },
    {
        key: "bookingNo",
        label: "BOOKING NO.",
        sticky: "left",
        width: 180,
        render: (row) => cell(row.bookingNo),
    },
    { key: "hbL_Number",               label: "HBL NUMBER",                 render: (row) => cell(row.hbL_Number) },
    { key: "bookingDate",              label: "BOOKING DATE",               render: (row) => formatReportDateTime(row.bookingDate) },
    { key: "officeType",               label: "PROFIT CENTER",              render: (row) => cell(row.officeType) },
    { key: "customerName",             label: "CUSTOMER NAME",              render: (row) => cell(row.customerName) },
    { key: "billToParty",              label: "BILL TO PARTY",              render: (row) => cell(row.billToParty) },
    { key: "vesselName",               label: "VESSEL NAME",                render: (row) => cell(row.vesselName) },
    { key: "salesPerson",              label: "SALES PERSON",               render: (row) => cell(row.salesPerson) },
    { key: "contactPerson",            label: "CONTACT PERSON",             render: (row) => cell(row.contactPerson) },
    {
        key: "rateQuoteNo",
        label: "RATE QUOTE#",
        render: (row) => {
            const v = row.rateQuoteNo;
            if (!v) return <span className="font-medium text-red-600 dark:text-red-400">N/A</span>;
            return <span className="text-blue-600 dark:text-blue-400">{v}</span>;
        },
    },
    { key: "containerDetails",         label: "CONT. DETAILS",              render: (row) => cell(row.containerDetails) },
    { key: "carrierName",              label: "CARRIER NAME",               render: (row) => cell(row.carrierName) },
    { key: "pol",                      label: "POL",                        render: (row) => cell(row.pol) },
    { key: "pod",                      label: "POD",                        render: (row) => cell(row.pod) },
    { key: "origin",                   label: "ORIGIN",                     render: (row) => cell(row.origin) },
    { key: "destination",              label: "DESTINATION",                render: (row) => cell(row.destination) },
    { key: "docsCO",                   label: "DOCS C/O",                   render: (row) => formatReportDateTime(row.docsCO) },
    { key: "ets",                      label: "ETS",                        render: (row) => formatReportDateTime(row.ets) },
    { key: "eta",                      label: "ETA",                        render: (row) => formatReportDateTime(row.eta) },
    { key: "transshipPort1",           label: "TRANSSHIP PORT 1",           render: (row) => cell(row.transshipPort1) },
    { key: "transshipVesselVoyage1",   label: "TRANSSHIP VESSEL VOYAGE 1",  render: (row) => cell(row.transshipVesselVoyage1) },
    { key: "etaTransship1",            label: "ETA TRANSSHIP 1",            render: (row) => formatReportDateTime(row.etaTransship1) },
    { key: "etdTransship1",            label: "ETD TRANSSHIP 1",            render: (row) => formatReportDateTime(row.etdTransship1) },
    { key: "transshipPort2",           label: "TRANSSHIP PORT 2",           render: (row) => cell(row.transshipPort2) },
    { key: "transshipVesselVoyage2",   label: "TRANSSHIP VESSEL VOYAGE 2",  render: (row) => cell(row.transshipVesselVoyage2) },
    { key: "etaTransship2",            label: "ETA TRANSSHIP 2",            render: (row) => formatReportDateTime(row.etaTransship2) },
    { key: "etdTransship2",            label: "ETD TRANSSHIP 2",            render: (row) => formatReportDateTime(row.etdTransship2) },
    { key: "sell",                     label: "SELL",                       render: (row) => row.sell == null ? "-" : formatReportCurrency(row.sell) },
    { key: "profit",                   label: "PROFIT",                     render: (row) => row.profit == null ? "-" : formatReportCurrency(row.profit) },
    {
        key: "profitMargin",
        label: "PROFIT MARGIN",
        render: (row) =>
            row.profitMargin == null
                ? "-"
                : `${(Number(row.profitMargin) * 100).toFixed(2)}%`,
    },
    { key: "hblReleaseMode",           label: "HBL RELEASE MODE",           render: (row) => cell(row.hblReleaseMode) },
    { key: "containerOnboard",         label: "CONTAINER ONBOARD",          render: (row) => cell(row.containerOnboard) },
    { key: "complexity",               label: "COMPLEXITY",                 render: (row) => cell(row.complexity) },
];

export const EXPORT_CONTAINER_TEUS_COLUMNS = [
    {
        key: "containerType",
        label: "CONTAINER TYPE",
        render: (row) => getContainerTypeFromRow(row),
        exportValue: (row) => getContainerTypeFromRow(row),
    },
    {
        key: "_20TUES",
        label: "20' TEUS",
        render: (row) => Number(row._20TUES ?? row._20Teus ?? 0).toFixed(2),
        exportValue: (row) => Number(row._20TUES ?? row._20Teus ?? 0).toFixed(2),
    },
    {
        key: "_40TUES",
        label: "40' TEUS",
        render: (row) => Number(row._40TUES ?? row._40Teus ?? 0).toFixed(2),
        exportValue: (row) => Number(row._40TUES ?? row._40Teus ?? 0).toFixed(2),
    },
    {
        key: "totalTues",
        label: "TOTAL TEUS",
        render: (row) => (
            <span className="font-semibold text-emerald-700 dark:text-emerald-400">
                {Number(getContainerTeusFromRow(row)).toFixed(2)}
            </span>
        ),
        exportValue: (row) => Number(getContainerTeusFromRow(row)).toFixed(2),
    },
];
